import { RouterProvider } from "react-router-dom";
import router from "./routes/router";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
} from "@apollo/client";
import { persistCache } from "apollo3-cache-persist";
import { setContext } from "@apollo/client/link/context";
import Spinner from "./components/Spinner";
import { useState, useEffect } from "react";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./components/Toast/ToastContext";
import { ListingContextProvider } from "./context/ListingContext";
import ErrorBoundary from "./components/ErrorBoundary";
import { ApolloLink } from "@apollo/client";
import { onError } from "@apollo/client/link/error";

const cache = new InMemoryCache();
//replace localhost with ur ip address, if you are testing this on Expo GO.

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_SERVER_ENDPOINT}/graphql`
});

const authLink = setContext(async (_, { headers }) => {
  const token = localStorage.getItem("userToken");
  return {
    headers: {
      ...headers,
      authorization: token ? `${token}` : "",
    },
  };
});



const errorLink = onError(({ graphQLErrors }) => {
  if(graphQLErrors?.[0]?.extensions?.code === "FORBIDDEN") {
    console.log("FORBIDDEN Error occured")
    localStorage.removeItem("userToken");
  }
});

export const client = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink.concat(httpLink)]),
  cache: cache,
});

const App = () => {
  const [loadingCache, setLoadingCache] = useState(true);

  useEffect(() => {
    persistCache({
      cache,
      storage: localStorage,
    }).then(() => setLoadingCache(false));
  }, []);

  if (loadingCache) return <Spinner />;

  return (
    <ErrorBoundary>
      <ListingContextProvider>
        <ApolloProvider client={client}>
          <AuthProvider>
            <ToastProvider>
              <RouterProvider
                router={router}
                future={{ v7_startTransition: true }}
              />
            </ToastProvider>
          </AuthProvider>
        </ApolloProvider>
      </ListingContextProvider>
    </ErrorBoundary>
  );
};

export default App;
